export const CERT_MODAL = {
  titleEn: "Certified standards, trusted worldwide.",
  titleRu: "Сертифицированные стандарты, которым доверяют во всём мире.",
  bodyEn:
    "Our certifications reflect a commitment to responsible farming, fair labour and secure international trade. Each program is independently audited and renewed on a regular cycle. Detailed certification documents are available to partners through the client area in the production version.",
  bodyRu:
    "Наши сертификаты подтверждают приверженность ответственному земледелию, справедливым условиям труда и безопасной международной торговле. Каждая программа проходит независимый аудит и регулярно обновляется. Подробные документы доступны партнёрам в клиентском разделе рабочей версии.",
};
